import type { CardOriginChannel } from '@voll-intelligence/domain';

import { AppIcons, type AppIconName } from '@web/ui/core/atoms';

const META: Record<CardOriginChannel, { icon: AppIconName; label: string }> = {
  whatsapp: { icon: 'whatsapp', label: 'whatsapp' },
  email: { icon: 'envelope', label: 'e-mail' },
  phone: { icon: 'device-mobile', label: 'telefone' },
  voucher: { icon: 'ticket', label: 'voucher' },
  ticket: { icon: 'chat-circle', label: 'ticket' },
  slack: { icon: 'slack', label: 'slack' },
  sms: { icon: 'chat-circle-text', label: 'sms' },
  teams: { icon: 'teams', label: 'teams' },
  zendesk: { icon: 'lifebuoy', label: 'zendesk' },
  sunshine: { icon: 'sun', label: 'sunshine' },
  app: { icon: 'chat-circle-dots', label: 'app' },
};

/** Icon name for a channel — shared with filter chips that render their own label. */
export function channelIcon(channel: CardOriginChannel): AppIconName {
  return META[channel].icon;
}

/**
 * Channel chip — icon + label for the conversation's origin channel.
 * Used on the conversa card meta row and inside the drawer header.
 */
export function ChannelChip({
  channel,
}: Readonly<{ channel: CardOriginChannel }>): React.JSX.Element {
  const { icon, label } = META[channel];
  return (
    <span className="inline-flex items-center gap-1 text-muted-foreground">
      <AppIcons name={icon} size={12} />
      <span className="font-mono text-card-id">{label}</span>
    </span>
  );
}
